module.exports = __webpack_public_path__ + "img/Header_Desktop_Logo.3c9279e9.png";